import { render } from "./DashboardsIndicatorCardsWithModals.vue?vue&type=template&id=58caf7be&scoped=true&ts=true"
import script from "./DashboardsIndicatorCardsWithModals.vue?vue&type=script&lang=ts"
export * from "./DashboardsIndicatorCardsWithModals.vue?vue&type=script&lang=ts"

import "./DashboardsIndicatorCardsWithModals.vue?vue&type=style&index=0&id=58caf7be&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58caf7be"]])

export default __exports__